<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="4"
        lg="4"
        offset-lg="3"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">

                    <b-form-group
                      :label="$t('DEBTIA_DEFAULT_KEY')"
                      label-for="default-default"
                    >
                      <v-select
                        v-model="selected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="settingKeysOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        input-id="default-default"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'default_termsheetcode'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="termsheetCodeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'is_default_interest_rate'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="interestRateOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'debtors_own_by'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="debtorsOwnByOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'maximum_reminder_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Maximum Reminder Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'maximum_compensation_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Maximum Compensation Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'minimum_case_amount'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Minimum Case Amount"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'transfer_court_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Transfer Court Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'foreign_collection_cost'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Foreign Collection Cost"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row
                  v-if="selected == 'own_collection_cost'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Own Collection Cost"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <!-- <b-row
                  v-if="selected == 'default_termsheetcode'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="termsheetCodeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      block
                      variant="primary"
                      @click="postSettingValues"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
          <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    BOverlay,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: 'debtors_own_by',
      settingKeysOptions: [
        { label: 'Debtors Own by', value: 'debtors_own_by' },
        { label: 'Default TermSheetCode', value: 'default_termsheetcode' },
        { label: 'Use Default Interest Rate', value: 'is_default_interest_rate' },
        { label: 'Maximum Reminder Fee', value: 'maximum_reminder_fee' },
        { label: 'Maximum Compensation Fee', value: 'maximum_compensation_fee' },
        { label: 'Minimum Case Amount', value: 'minimum_case_amount' },
        { label: 'Transfer Court Fee', value: 'transfer_court_fee' },
        { label: 'Foreign Collection Cost', value: 'foreign_collection_cost' },
        { label: 'Own Collection Cost', value: 'own_collection_cost' },
      ],
      debtorsOwnByOptions: [
        { label: 'Company', value: 'company' },
        { label: 'Client', value: 'client' },
      ],
      termsheetCodeOptions: [],
      settingsData: {
        key: '',
        value: '',
      },
      interestRateOptions: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      loader: false,
      required,
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(newValue) {
        this.getSettingValues(newValue)
      },
    },
  },
  created() {
    this.getSettingValues('debtors_own_by')
    this.getTermsheetcodeDropdown()
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    getSettingValues(selected) {
      this.loader = true
      axios.get('user-settings/get', { params: { key: selected } }).then(response => {
        const settingDetails = response.data.data
        // console.log('settingDetails', settingDetails)
        this.settingsData.key = selected
        // console.log('selected is ', settingDetails.value)
        if (settingDetails === null) {
          this.getDefaultValues(selected)
        } else if (selected === 'is_default_interest_rate') {
          if (settingDetails.value === '1') {
            this.settingsData.value = true
          } else if (settingDetails.value === '0') {
            this.settingsData.value = false
          }
        } else {
          this.settingsData.value = settingDetails.value
        }
        this.loader = false
      }).catch(() => {
        this.getDefaultValues(selected)
        this.loader = false
      })
    },
    getTermsheetcodeDropdown() {
      this.loader = true
      axios.get('settings/termsheetcode-dropdown').then(response => {
        const settingDetails = response.data.data
        if (settingDetails !== null) {
          this.termsheetCodeOptions = response.data.data
        }
        this.loader = false
      })
    },
    getDefaultValues(key) {
      console.log('key', key)
      if (key === 'debtors_own_by') {
        this.settingsData.value = 'company'
      } if (key === 'default_termsheetcode') {
        this.settingsData.value = ''
      } if (key === 'is_default_interest_ratee') {
        this.settingsData.value = true
      }
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.settingsData.key = this.selected
            this.loader = true
            axios.post('user-settings/save', [this.settingsData]).then(response => {
              this.loader = false
              // console.log(response)
              if (response.data.data[0].key === 'debtors_own_by') {
                localStorage.setItem('debtorsBelongTo', response.data.data[0].value)
              }
              this.makeSuccessToast()
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
